<div class="dialog-header">
  <h2 mat-dialog-title>{{ 'enterprise_contract.update_information_dialog.title' | translate }}</h2>
  <button mat-icon-button type="button" [disabled]="saving" (click)="cancel()" [attr.aria-label]="'button.cancel' | translate">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="dialog-content">
  <div class="form-pane" [class.applying]="applying || saving" [attr.aria-busy]="loading || applying || saving">
    <div *ngIf="loading" class="form-loading" role="status" [attr.aria-label]="'enterprise_contract.update_information_dialog.loading' | translate">
      <i nz-icon nzType="loading" aria-hidden="true"></i>
    </div>
    <p *ngIf="loadError" role="alert" class="error-message">{{ 'enterprise_contract.update_information_dialog.table_load_error' | translate }}</p>
    <p *ngIf="templateLoadError" role="alert" class="error-message">{{ 'enterprise_contract.update_information_dialog.template_load_error' | translate }}</p>
    <app-negotiation-form *ngIf="formModel && !loadError" (formReady)="onFormReady()" (formLoadError)="onFormLoadError()"
                          (requiredFieldsCompleteChange)="requiredFieldsComplete = $event"
                          (valuesChange)="onFormValuesChange()"></app-negotiation-form>
  </div>
  <div class="preview-pane" [attr.aria-busy]="previewLoading">
    <div class="file-name" [title]="fileName">
      <span *ngIf="previewLoading" role="status" [attr.aria-label]="'enterprise_contract.update_information_dialog.loading' | translate">
        <i nz-icon nzType="loading" aria-hidden="true"></i>
      </span>
      <span class="file-name-text">{{ fileName }}</span>
    </div>
    <p *ngIf="previewError" role="alert" class="error-message">{{ 'enterprise_contract.update_information_dialog.preview_error' | translate }}</p>
    <ngx-extended-pdf-viewer *ngIf="pdfSrc" [src]="pdfSrc" [(page)]="pageCurrent"
                             [(zoom)]="zoomLevel" useBrowserLocale="true"
                             height="100%" [showPrintButton]="false" [enablePrint]="true"
                             [showDownloadButton]="false" [sidebarVisible]="true"
                             [showRotateButton]="false" [showOpenFileButton]="false"
                             [showBookmarkButton]="false" [showPropertiesButton]="false"
                             [showUnverifiedSignatures]="true" [theme]="'dark'"
                             [language]="language" [showSecondaryToolbarButton]="false"
                             [showSidebarButton]="true" [textLayer]="true"
                             (pdfLoaded)="onPreviewLoaded()"
                             (pdfLoadingFailed)="onPreviewLoadError()">
    </ngx-extended-pdf-viewer>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-stroked-button color="primary" type="button" [disabled]="saving" (click)="cancel()">
    <mat-icon>cancel</mat-icon> {{ 'button.cancel' | translate }}
  </button>
  <button mat-stroked-button color="primary" type="button" [disabled]="!ready || !templateReady || applying || saving" (click)="apply()">
    <mat-icon>check_box</mat-icon> {{ 'enterprise_contract.update_information_dialog.apply' | translate }}
  </button>
  <button mat-raised-button color="primary" type="button" [disabled]="!canSave" (click)="save()">
    <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
  </button>
</mat-dialog-actions>
